import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Stklm { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @MaxLength(20,{message: '帳號 (account) 資料太長'})
    account: string = '';            // 帳號 20 

    @IsNumber() 
    AfterQty: number = 0;            // 異動變更後量 8 (僅提供證券、複委託市場)參考欄位，異動變更後量，刪單為空值

    @MaxLength(4,{message: '委託介面 (Agent) 資料太長'})
    Agent: string = '';            // 委託介面 4 EX:y d1

    @IsNumber() 
    BeforeQty: number = 0;            // 異動變更前量 8 (僅提供證券、複委託市場)參考欄位，刪單為空值

    @MaxLength(10,{message: '分公司代號 (Broker) 資料太長'})
    Broker: string = '';            // 分公司代號 10 EX:9184,	TS,TA,TL,TP:  unit no TF,TO: IB 代號 broker id EX:F020000

    @MaxLength(10,{message: 'BuySell (BuySell) 資料太長'})
    BuySell: string = '';            // BuySell 10 EX:S00R2 BNI30

    @MaxLength(1,{message: '選擇權類型 (CallPut) 資料太長'})
    CallPut: string = '';            // 選擇權類型 1 {{C:Call P:Put}}

    @MaxLength(1,{message: '交易所動態退單代碼 (CancelOrderE) 資料太長'})
    CancelOrderE: string = '';            // 交易所動態退單代碼 1 E:交易所動態退單  N    CancelOrderMarkByExchange

    @MaxLength(20,{message: '商品代碼 (COMID) 資料太長'})
    COMID: string = '';            // 商品代碼 20 ComId

    @MaxLength(20,{message: '第一腳商品代碼 (ComId1) 資料太長'})
    ComId1: string = '';            // 第一腳商品代碼 20 FITM

    @MaxLength(20,{message: '第二腳商品代碼 (ComId2) 資料太長'})
    ComId2: string = '';            // 第二腳商品代碼 20 

    @MaxLength(12,{message: '交易帳號 (CustNo) 資料太長'})
    CustNo: string = '';            // 交易帳號 12 EX:0128692

    @MaxLength(8,{message: '交易日期 (Date1) 資料太長'})
    Date1: string = '';            // 交易日期 8 20241111

    @IsNumber() 
    Denominator: number = 0;            // 分母 6 海外期貨回報用，

    @IsNumber() 
    Denominator1: number = 0;            // 觸發價格分母 11.4 海外期貨回報用，

    @IsNumber() 
    Denominator2: number = 0;            // 第二腳觸發價格分母 11.4 

    @MaxLength(255,{message: '委託單錯誤訊息 (ErrorMsg) 資料太長'})
    ErrorMsg: string = '';            // 委託單錯誤訊息 255 當第四欄位OrderErr為Y時，委託單錯誤訊息

    @MaxLength(5,{message: '交易所 (ExchangeID) 資料太長'})
    ExchangeID: string = '';            // 交易所 5 EX:TW

    @MaxLength(20,{message: '成交序號 (ExecutionNo) 資料太長'})
    ExecutionNo: string = '';            // 成交序號 20 11碼  0000001215

    @MaxLength(10,{message: '交易所或後台退單訊息 (ExTandemMsg) 資料太長'})
    ExTandemMsg: string = '';            // 交易所或後台退單訊息 10 ExchangeTandemMsg  [00]:2碼數字,交易所回應代碼及訊息; [000]:3碼數字,交易後台代碼及訊息; [D]委託成功後,由交易所主動退單及退單原因

    @MaxLength(1,{message: '流程碼 (KEY1) 資料太長'})
    KEY1: string = '1';            // 流程碼 1 [DEF:"1"]

    @MaxLength(40,{message: 'KEYNO (keyNo) 資料太長'})
    keyNo: string = '';            // KEYNO 40 

    @IsNotEmpty({message: '回報流水號 (LM001) 不可空白'}) 
    @MaxLength(20,{message: '回報流水號 (LM001) 資料太長'})
    LM001: string = '';            // 回報流水號 20 

    @MaxLength(2,{message: '市場別 (MarketType) 資料太長'})
    MarketType: string = '';            // 市場別 2 {{TS:證券 TA:盤後 TL:零股 TP:興櫃 TC:盤中零股 TF:期貨 TO:選擇權 OF:海期 OO:海選 OS:複委託}}

    @MaxLength(13,{message: '回報流水號 (MsgNo) 資料太長'})
    MsgNo: string = '';            // 回報流水號 13 EX:1010001045466 2120000059365 13碼

    @IsNumber() 
    Numerator: number = 0;            // 分子 6 海外期貨回報用，

    @IsNumber() 
    Numerator1: number = 0;            // 第一腳觸發價格分子 11.4 海外期貨回報用，

    @IsNumber() 
    Numerator2: number = 0;            // 第二腳觸發價格分子 11.4 

    @MaxLength(1,{message: '停損限價/停損市價 (OFSTPFlag) 資料太長'})
    OFSTPFlag: string = '';            // 停損限價/停損市價 1 [海期][停損限價/停損市價][已觸發]

    @MaxLength(20,{message: '成交序號 (OkSeq) 資料太長'})
    OkSeq: string = '';            // 成交序號 20 (請以ExecutionNo為主)    股票 空白

    @MaxLength(8,{message: '有效委託日 (OrderEff) 資料太長'})
    OrderEff: string = '';            // 有效委託日 8 OrderEffective

    @MaxLength(1,{message: '錯誤碼 (OrderErr) 資料太長'})
    OrderErr: string = '';            // 錯誤碼 1 {{Y:失敗 T:逾時 N:正常}}

    @MaxLength(10,{message: '委託書號 (OrderNo) 資料太長'})
    OrderNo: string = '';            // 委託書號 10 EX:T00X6

    @MaxLength(20,{message: '交易所單號 (OrderSeq) 資料太長'})
    OrderSeq: string = '';            // 交易所單號 20 (僅海期選)，依海外交易所實際提供為主，又稱上手單號

    @MaxLength(1,{message: '盤中單/預約單 (PreOrder) 資料太長'})
    PreOrder: string = '';            // 盤中單/預約單 1 {{A:盤中單 B:預約單}}  (僅國內期、選委託)

    @IsNumber() 
    Price: number = 0;            // 價格 11.4 代表已經處理的價格 其餘為根據 Type 種類不同 N:「委託」為委託價；D:「成交」為成交價 EX:13.0000

    @IsNumber() 
    Price1: number = 0;            // 第一腳成交價 11.4 海外期貨回報用，觸發價格 國內期選成交時，

    @IsNumber() 
    Price2: number = 0;            // 第二腳成交價 11.4 國內期選成交時，

    @MaxLength(4,{message: '下單期標 (PriceSymbol) 資料太長'})
    PriceSymbol: string = '';            // 下單期標 4 

    @IsNumber() 
    QTY: number = 0;            // Qty 8 TS TC OS股數 TF TO OF OO口數   根據 Type 種類   N:「委託」為委託量，D:「成交」為成交量   U:「改量」為減量數，C:「刪單」為原委託剩量

    @MaxLength(1,{message: '盤別 (Reserved) 資料太長'})
    Reserved: string = '';            // 盤別 1 (僅國內期、選委託) {{A:T盤  B:T+1盤}}

    @MaxLength(10,{message: '營業員編號 (SaleNo) 資料太長'})
    SaleNo: string = '';            // 營業員編號 10 EX:0196

    @MaxLength(13,{message: '13碼序號 (SeqNo) 資料太長'})
    SeqNo: string = '';            // 13碼序號 13 (成交單含IOC/FOK產生取消單) 4311111174839

    @IsNumber() 
    StrikePrice: number = 0;            // 履約價 11 七位整數(配合舊回報資料保留欄位)履約價敬請參考 StrikePrice1 and StrikePrice2  股票 空白

    @IsNumber() 
    StrikePrice1: number = 0;            // 第一腳商品履約價 11.4 

    @IsNumber() 
    StrikePrice2: number = 0;            // 第二腳商品履約價 11.4 

    @MaxLength(10,{message: '子帳帳號 (SubID) 資料太長'})
    SubID: string = '';            // 子帳帳號 10 

    @MaxLength(8,{message: '交易時間 (Time) 資料太長'})
    Time: string = '';            // 交易時間 8 (含冒號EX: 01:02:03)

    @MaxLength(8,{message: '委託日期 (TradeDate) 資料太長'})
    TradeDate: string = '';            // 委託日期 8 (僅提供海外委託，國內尚未提供)    V8

    @MaxLength(1,{message: 'TYPE (type1) 資料太長'})
    type1: string = '';            // TYPE 1 {{N:委託 C:取消 U:改量 P:改價 D:成交 B:改價改量 S:動態退單}}

    @MaxLength(10,{message: 'userid (uid) 資料太長'})
    uid: string = '';            // userid 10 

    @MaxLength(6,{message: '第一腳商品結算年月 (YearMonth1) 資料太長'})
    YearMonth1: string = '';            // 第一腳商品結算年月 6 202411

    @MaxLength(6,{message: '第二腳商品結算年月 (YearMonth2) 資料太長'})
    YearMonth2: string = '';            // 第二腳商品結算年月 6 


}
